import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactModal from 'react-modal';
import { Box, Button, CircularProgress, Grid } from '@material-ui/core';
import _ from 'lodash';
import { mobilizeiStoresService } from '../_services/mobilizei/stores.service';
import { withFirebase } from '../_firebase';
import 'firebase/firestore';

ReactModal.setAppElement('#root')

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(10, 10, 10, 0.45)',
        zIndex: 999
    },
    content: {
        height: 'fit-content',
        width: '35%',
        margin: 'auto'
    }
};

const useStyles = makeStyles(() => ({
    title: {
        marginTop: 0
    },
    subtitle: {
        fontSize: 16,
        color: '#3C4252',
    },
    text: {
        fontSize: 14,
        color: '#a1a1a1',
    },
    alert: {
        fontSize: 14,
        color: '#ff2457',
    }
}))

function UnlinkExpoProjectDialog({ data, isOpen, onClose, onDataUpdate, platformId }) {
    const classes = useStyles();

    const [loading, setLoading] = useState(false);

    const expoProjectId = _.get(data, 'expoProjectId', '');
    const expoAccountName = _.get(data, 'expoAccountName', '');
    const canUnlink = !!expoProjectId;

    const handleUnlink = () => {
        setLoading(true);

        mobilizeiStoresService.unlinkExpoProject(platformId, data.id)
          .then(() => {
              onDataUpdate();
              onClose();
          })
          .catch((e) => {
              console.log(e)
              alert(`Não foi possível desvincular o projeto Expo da loja.`)
          })
          .finally(() => setLoading(false))
    }

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={() => onClose()}
            style={customStyles}
        >
            <h2 align="center" className={classes.title}>Desvincular projeto Expo</h2>

            <Box alignItems="center" justify='center' m={6} >
                <h4 align="center" className={classes.subtitle}>
                  Deseja realmente desvincular o projeto Expo desta loja?
                </h4>

                {canUnlink && (
                    <Box display='grid' justifyContent='center' gridGap={10}>
                        <h4 align="center" className={classes.text}>
                            Projeto: {expoProjectId}
                        </h4>
                        {expoAccountName && (
                            <h4 align="center" className={classes.text}>
                                Conta Expo: {expoAccountName}
                            </h4>
                        )}
                        <h4 align="center" className={classes.text}>
                            Isso apenas remove a referência ao projeto na nossa base (liberando o slot
                            da conta Expo no nosso controle) e limpa as credenciais iOS da loja.
                        </h4>
                        <h4 align="center" className={classes.alert}>
                            O projeto NÃO é excluído no Expo — a exclusão exige confirmação manual
                            no site do Expo (expo.dev).
                        </h4>
                    </Box>
                )}
            </Box>

            <Grid container alignItems="flex-start" spacing={2}>
                <Grid container justify="center" item xs={12}>
                    {canUnlink
                        ? (
                            <>
                                {loading ? <CircularProgress /> :
                                    <Button variant="contained" color="primary" onClick={handleUnlink}>
                                        Desvincular projeto
                                    </Button>
                                }
                            </>
                        )
                        : (
                            <>
                                <Button disabled variant="contained" color="primary">
                                    Nenhum projeto Expo para desvincular
                                </Button>
                                <h4 align="center" className={classes.alert} color='secondary'>
                                    A loja não possui um expoProjectId preenchido
                                </h4>
                            </>
                        )
                    }
                </Grid>
            </Grid>
        </ReactModal>
    )
}

export default withFirebase(UnlinkExpoProjectDialog);
